// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KUi3","left":"styles_left__2YaiI"};